import { graphql } from 'react-relay';

export const tryLeaveUserNameQuery = graphql`
  query leaveUserNameQuery {
    bznavRefund {
      user {
        name
      }
    }
  }
`;
